'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { cn } from '@morpho-org/ui-v6/utils';
import { useIsBelowBreakpoint } from '@/hooks/useBreakpoints';
import SectionLayout from '../layout/SectionLayout/SectionLayout';
import SimpleActionPanelStickyContainer, { SIMPLE_ACTION_PANEL_GRID } from '../layout/SectionLayout/SimpleActionPanelStickyContainer';
import MarketPageMobileLayout from './MarketPageMobileLayout';
import { MarketTabs } from './MarketTabs';
export interface MarketPageLayoutProps {
  simpleActionPanelSlot: ReactNode;
  heroSlot: ReactNode;
  calloutSlot?: ReactNode;
  marketSlots: ReactNode;
  ratesSlots: ReactNode;
  riskSlots: ReactNode;
  activitySlots: ReactNode;
  yourPositionSlots: ReactNode;
}
export default function MarketPageLayout(t0) {
  const $ = _c(25);
  const {
    simpleActionPanelSlot,
    calloutSlot,
    yourPositionSlots,
    marketSlots,
    ratesSlots,
    riskSlots,
    activitySlots,
    heroSlot
  } = t0;
  const isSmallScreen = useIsBelowBreakpoint("s");
  if (isSmallScreen) {
    let t1;
    if ($[0] !== activitySlots || $[1] !== calloutSlot || $[2] !== heroSlot || $[3] !== marketSlots || $[4] !== ratesSlots || $[5] !== riskSlots || $[6] !== simpleActionPanelSlot || $[7] !== yourPositionSlots) {
      t1 = <MarketPageMobileLayout simpleActionPanelSlot={simpleActionPanelSlot} heroSlot={heroSlot} calloutSlot={calloutSlot} yourPositionSlots={yourPositionSlots} marketSlots={marketSlots} ratesSlots={ratesSlots} riskSlots={riskSlots} activitySlots={activitySlots} />;
      $[0] = activitySlots;
      $[1] = calloutSlot;
      $[2] = heroSlot;
      $[3] = marketSlots;
      $[4] = ratesSlots;
      $[5] = riskSlots;
      $[6] = simpleActionPanelSlot;
      $[7] = yourPositionSlots;
      $[8] = t1;
    } else {
      t1 = $[8];
    }
    return t1;
  }
  let t1;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("w-full min-w-0", SIMPLE_ACTION_PANEL_GRID);
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  let t2;
  if ($[10] !== activitySlots || $[11] !== marketSlots || $[12] !== ratesSlots || $[13] !== riskSlots || $[14] !== yourPositionSlots) {
    t2 = <MarketTabs marketSlots={marketSlots} ratesSlots={ratesSlots} riskSlots={riskSlots} activitySlots={activitySlots} yourPositionSlots={yourPositionSlots} />;
    $[10] = activitySlots;
    $[11] = marketSlots;
    $[12] = ratesSlots;
    $[13] = riskSlots;
    $[14] = yourPositionSlots;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  let t3;
  if ($[16] !== calloutSlot || $[17] !== heroSlot || $[18] !== t2) {
    t3 = <SectionLayout hasLargerVerticalPadding={true} noBackground={true}><div className="flex w-full flex-col gap-[64px]">{heroSlot}{calloutSlot}{t2}</div></SectionLayout>;
    $[16] = calloutSlot;
    $[17] = heroSlot;
    $[18] = t2;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  let t4;
  if ($[20] !== simpleActionPanelSlot) {
    t4 = <SimpleActionPanelStickyContainer>{simpleActionPanelSlot}</SimpleActionPanelStickyContainer>;
    $[20] = simpleActionPanelSlot;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  let t5;
  if ($[22] !== t3 || $[23] !== t4) {
    t5 = <div className={t1}>{t3}{t4}</div>;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
  } else {
    t5 = $[24];
  }
  return t5;
}